import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { SweetAlert } from "../../helpers/helper";

const AssignVehicleModal = ({
  show,
  onClose,
  onSubmit,
  tyre,
  vehicles,
  loading,
}) => {
  const [vehicleId, setNewVehicle] = useState("");
  const [description, setDescription] = useState("");
  const [installationDate, setNewInstallationDate] = useState("");
  const [validated, setValidated] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!vehicleId || !installationDate) {
      SweetAlert("Please select a vehicle and installation date", false);
      return;
    }
    const payload = {
      tyreId: tyre._id,
      vehicleId,
      description,
      installationDate,
    };
    onSubmit(payload);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      handleSubmit(event); // Call your submit function
    }

    setValidated(true);
  };

  const handleClear = () => {
    setNewVehicle("");
    setDescription("");
    setNewInstallationDate("");
    setValidated(false);
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Assign Vehicle to Tyre ({tyre?.tyreNo})</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate validated={validated} onSubmit={handleFormSubmit}>
          <Row key={1} className="mb-2 p-2 rounded">
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Select New Vehicle</Form.Label>
                <Form.Select
                  value={vehicleId}
                  onChange={(e) => setNewVehicle(e.target.value)}
                  required
                  isInvalid={validated && !vehicleId}
                >
                  {vehicles.map((vehicle) => (
                    <option key={vehicle.value} value={vehicle.value}>
                      {vehicle.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Please select a vehicle.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            {/* Installation Date */}
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>New Installation Date</Form.Label>
                <Form.Control
                  type="date"
                  value={installationDate}
                  onChange={(e) => setNewInstallationDate(e.target.value)}
                  required
                  isInvalid={validated && !installationDate}
                />
                <Form.Control.Feedback type="invalid">
                  Installation date is required.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Description */}
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter installation details (optional)"
                  required
                  isInvalid={validated && !description}
                  maxLength={100}
                />
                <Form.Control.Feedback type="invalid">
                  Description is required.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={handleClear} className="me-2">
              Clear
            </Button>
            <Button variant="primary" type="submit" loading={loading}>
              Assign Vehicle
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AssignVehicleModal;
